import styled from 'styled-components';

const PDFModalWrapper = styled.div`
  width: 70vw;
  height: 70vh;
  .file-box {
    width: 100%;
    height: 100%;
  }
`;

export default PDFModalWrapper;
